import React from 'react';
import {connect} from "react-redux";
import {selectVas, cancelVas, changeVasItems} from "../actions/index";
import {getVases, getVasesPrices, getSelectedVasIds, getSelectedVasItems, getCurrencySymbol} from "../reducers/index";
import Vases from "../component/Vases";

const mapStateToProps = state => {
    return {
        vases: getVases(state),
        vasesPrices: getVasesPrices(state),
        currencySymbol: getCurrencySymbol(state),
        selectedVasIds: getSelectedVasIds(state),
        selectedVasItems: getSelectedVasItems(state),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectVas: vasId => {
            dispatch(selectVas(vasId))
        },
        onCancelVas: vasId => {
            dispatch(cancelVas(vasId))
        },
        oncChangeVasItems: (vasId, itemsCount) => {
            dispatch(changeVasItems(vasId, itemsCount))
        },
    }
}

const VasesContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Vases)

export default VasesContainer;